  $(document).ready(function () {
      $('.hero-slider').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'ease-in-out',
        swipe: true,
        pauseOnHover: false,
        touchMove: true,
        draggable: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              dots: false,
            },
          },
          {
            breakpoint: 768,
            settings: {
              dots: false,
            },
          },
        ],
      });
    });